import {
  DEFAULT_LONG_FORMAT,
  getDateFromSeconds,
  getDateInUserLocale
} from "@/helpers/date.helpers"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { DismissedBy } from "@/molecules/DismissedTag"

import styles from "./StatusBar.module.scss"

import type { DismissedMetaRecord } from "@/molecules/IssueStatusAlert"

// "by X on date", or "Dismissed by X on date" next to a second status label
export const DismissedMeta = (props: {
  record: DismissedMetaRecord
  withStatus?: boolean
}) => {
  const { record, withStatus } = props
  const { dismissedBy, dismissMethod, dismissedAt } = record
  const { t: tEntity } = useTranslation("translation", {
    keyPrefix: "dismissedEntity"
  })
  const date = getDateInUserLocale(
    getDateFromSeconds(dismissedAt),
    DEFAULT_LONG_FORMAT
  )
  const withDateKey = withStatus ? "dismissedByOn" : "byOn"

  return (
    <span className={styles.actorLine}>
      <Trans
        i18nKey={`issue.statusBar.${date ? withDateKey : "by"}`}
        values={{ date }}
        components={{
          actor: (
            <span className={styles.actor}>
              <DismissedBy
                dismissedBy={dismissedBy}
                dismissMethod={dismissMethod}
                t={tEntity}
              />
            </span>
          )
        }}
      />
    </span>
  )
}
